import { FaEnvelope, FaPhoneAlt } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="bg-softgreen text-dark text-sm py-8 mt-16">
      <div className="container mx-auto px-4 text-center flex flex-col items-center space-y-4">

        {/* Logo + Slogan */}
        <div className="flex flex-col items-center">
          <img src="/logo.png" alt="Logo Story Brand" className="h-12 mb-2" />
          <p className="text-xs italic text-gray-700">Votre histoire, notre stratégie.</p>
        </div>

        {/* Informations de contact */}
        <div className="flex flex-col sm:flex-row sm:justify-center sm:items-center space-y-2 sm:space-y-0 sm:space-x-6">
          <a
            href="mailto:contact@story-brand.fr"
            className="flex items-center justify-center gap-2 hover:text-yellow-400 transition"
          >
            <FaEnvelope size={16} color="#C9B548" />
            contact@story-brand.fr
          </a>
          <a
            href="tel:+33374472526"
            className="flex items-center justify-center gap-2 hover:text-yellow-400 transition"
          >
            <FaPhoneAlt size={16} color="#C9B548" />
            +33 3 74 47 25 26
          </a>
        </div>

        {/* Mentions */}
        <p className="text-xs text-gray-600">
          © {new Date().getFullYear()} Story Brand. Tous droits réservés.
        </p>
      </div>
    </footer>
  );
}
